import {Messages} from '../../constants';

const validation = {
  numero: {
    presence: {
      message: Messages.RequiredRgDocumentValidationMessage,
      allowEmpty: false,
    },
    length: {
      minimum: 5,
      tooShort: Messages.InvalidRgDocumentValidationMessage,
    },
  },
  uf: {
    presence: {
      message: Messages.RequiredUfDocumentValidationMessage,
      allowEmpty: false,
    },
  },
  orgaoExpedidor: {
    presence: {
      message: Messages.RequiredEmitterDocumentValidationMessage,
      allowEmpty: false,
    },
  },
  emissao: {
    presence: {
      message: Messages.RequiredIssueDateDocumentValidationMessage,
      allowEmpty: false,
    },
    brDate: {
      message: Messages.InvalidIssueDateDocumentValidationMessage,
    },
    lowestCurrentDate: {
      message: Messages.LowestCurrentDateIssueValidationMessage,
    },
  },
};

export default validation;
